import { useNavigation } from "react-router-dom"

/** Thin indeterminate bar shown while a lazy page chunk is loading. */
export function RouteProgress() {
  const navigation = useNavigation()
  if (navigation.state === "idle") return null

  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 z-50 h-0.5 overflow-hidden" role="progressbar" aria-label="Loading page">
      <div className="h-full w-full origin-left animate-progress bg-primary" />
    </div>
  )
}
